import { AssetType as u } from "../../../temp-lib/constants/url.js";
import f from "../../../temp-lib/hooks/generic/useApeironPathMaker.js";
import l from "../../../temp-lib/hooks/json/useFetchJson.js";
import { singleOperation as y } from "../../../temp-lib/util/operation/singleOperation.js";
import * as t from "ramda";
import { useCallback as e } from "react";
let n = null;
const h = "fetch_dictionary_data", g = () => {
  const { makePath: c } = f(), p = e(() => n, []), { fetchJson: o } = l({
    url: c(u.Json, "data/dictionary.json")
  }), i = e(
    () => async () => o(),
    [o]
  ), m = e(async () => {
    t.isNil(n) && (n = await y(h, i()));
  }, [i]), a = e((r) => {
    if (!t.is(Array, r) && !t.is(Object, r)) {
      if (t.is(String, r) && t.startsWith("api::", r)) {
        const s = t.last(t.split("::", r));
        return t.propOr(`missing_data_${s}`, s, n);
      }
      return r;
    }
    return t.map((s) => a(s), r);
  }, []);
  return {
    data: p,
    fetchData: m,
    injectData: a
  };
};
export {
  g as default
};
//# sourceMappingURL=useInjectDictionary.js.map
